import React, { useState } from "react";
import "./productCards.css";
import { Link } from "react-router-dom";
import Fabrisorb from "../../../../images/newproductslider/fabrisorb-pro.webp";
import FabrosorbDeco from "../../../../images/newproductslider/fabrosirb-deco-pro.webp";
import EchoEliminator from "../../../../images/newproductslider/echoeliminator-pro.webp";
import MLVB from "../../../../images/newproductslider/mlvb-pro.webp";
import Woodwool from "../../../../images/newproductslider/woodwool-pro.webp";
import Decopanel from "../../../../images/newproductslider/decopanel-pro.webp";
import Fabriwall from "../../../../images/newproductslider/fabriwall-pro.webp";
import Woodtec from "../../../../images/newproductslider/woodtec-pro.webp";
import Polyurethane from "../../../../images/newproductslider/polyurethane-pro.webp";
import Diffuso from "../../../../images/newproductslider/diffuso-pro.webp";
import Polymax from "../../../../images/newproductslider/polymax-pro.webp";
import Polysorb from "../../../../images/newproductslider/polysorb-pro.webp";
import PolysorbDeco from "../../../../images/newproductslider/polysorb-deco-pro.webp";
import Echotherm from "../../../../images/newproductslider/echotherm-pro.webp";
import Decowood from "../../../../images/newproductslider/decowood-pro.webp";
import AcoustyDoor from "../../../../images/newproductslider/soundproof-door-pro.webp";
import Knaufdanoline from "../../../../images/newproductslider/knauf-danoline-kraft.webp";
import PolyesterCT from "../../../../images/newproductslider/polyester-ceiling-titles-pro.webp";

const products = [
    {
        id: 1,
        name: "FabriSorb",
        category: "wall",
        route: "/fabrisorb",
        status: "available",
        image: Fabrisorb,
        description: "Decorative acoustic panels that absorb sound and reduce noise."
    },
    {
        id: 2,
        name: "FabriSorb-Deco",
        category: "ceiling",
        route: "/fabrisorb-deco",
        status: "available",
        image: FabrosorbDeco,
        description: "Fabrisorb-DECO acoustic panels are decorative, fabric-wrapped sound-absorbing solutions that combine high acoustic performance with customizable aesthetics for spaces like studios, offices, and auditoriums."
    },
    {
        id: 3,
        name: "Echo Eliminator<sup>TM</sup>",
        category: "baffle",
        route: "/echo-eliminator",
        status: "unavailable",
        image: EchoEliminator,
        description: "Echo Eliminator™ is a high-performance, eco-friendly acoustic panel made from recycled cotton, designed for effective noise absorption in spaces like gyms, classrooms, and multipurpose halls."
    },
    {
        id: 4,
        name: "MLVB",
        category: "designer",
        route: "/mass-loaded-vinyl",
        status: "available",
        image: MLVB,
        description: "MLVB is a dense, flexible barrier used to block sound and reduce noise transmission."
    },
    {
        id: 5,
        name: "Wood Wool",
        category: "designer",
        route: "/woodwool",
        status: "available",
        image: Woodwool,
        description: "Envirocoustic™ Wood Wool panels are eco-friendly acoustic panels made from natural wood and cement, offering durable, fire-resistant sound absorption with customizable finishes."
    },
    {
        id: 6,
        name: "D'ecopanel",
        category: "wall",
        route: "/decopanel",
        status: "available",
        image: Decopanel,
        description: "D’ecopanel is a customizable, eco-friendly acoustic PET panel system designed to reduce echo and improve sound quality in interior spaces."
    },
    {
        id: 7,
        name: "FabriWALL",
        category: "wall",
        route: "/fabriwall",
        status: "available",
        image: Fabriwall,
        description: "FabriWALL is a customizable stretch fabric acoustic system for sound absorption."
    },
    {
        id: 8,
        name: "WoodTEC",
        category: "designer",
        route: "/woodtec",
        status: "available",
        image: Woodtec,
        description: "WoodTEC is a wooden acoustic panel for sound absorption."
    },
    {
        id: 9,
        name: "FOAM STOP<sup>TM</sup>Polyurethane",
        category: "wall",
        route: "/foamstop-pu",
        status: "available",
        image: Polyurethane,
        description: "Foam Stop Polyurethane is an acoustic foam solution that reduces echo and noise by absorbing sound waves."
    },
    {
        id: 10,
        name: "Diffuso",
        category: "designer",
        route: "/diffuso",
        status: "available",
        image: Diffuso,
        description: "DIFFUSO is a wooden acoustic diffuser that scatters sound evenly to reduce echoes and improve room acoustics."
    },
    {
        id: 11,
        name: "Polymax<sup>TM</sup>",
        category: "wall",
        route: "/polymax-polyester",
        status: "available",
        image: Polymax,
        description: "Poly Max™ is a safe, eco-friendly polyester acoustic panel that absorbs sound while offering decorative and customizable finishes."
    },
    {
        id: 12,
        name: "Polysorb",
        category: "wall",
        route: "/polysorb",
        status: "available",
        image: Polysorb,
        description: "Polysorb™ is a cost-effective polyester acoustic panel that absorbs sound while being safe, durable, and decorative."
    },
    {
        id: 13,
        name: "Polysorb-Deco",
        category: "wall",
        route: "/polysorb-deco",
        status: "available",
        image: PolysorbDeco,
        description: "Polysorb-DECO is a decorative, eco-friendly acoustic panel that enhances sound absorption while adding a premium visual finish."
    },
    {
        id: 14,
        name: "Echotherm",
        category: "ceiling",
        route: "/echotherm",
        status: "available",
        image: Echotherm,
        description: "ECOTHERM is a carbon-neutral spray plaster that provides seamless acoustic and thermal insulation."
    },
    {
        id: 15,
        name: "Decowood",
        category: "designer",
        route: "/decowood",
        status: "available",
        image: Decowood,
        description: "DECOWOOD is an acoustic PET panel with a wooden finish that combines sound absorption with a premium aesthetic look."
    },
    {
        id: 16,
        name: "Acousty Door",
        category: "designer",
        route: "/soundproof-interior-doors",
        status: "available",
        image: AcoustyDoor,
        description: "Studio 3D™ Doors are high-performance soundproof interior doors designed to block noise effectively."
    },
    {
        id: 17,
        name: "Knauf Danoline Kraft",
        category: "ceiling",
        route: "/knaufdanoline",
        status: "available",
        image: Knaufdanoline,
        description: "Knauf Danoline Kraft is a seamless gypsum acoustic lining system that enhances sound absorption with a smooth, jointless finish."
    },
    {
        id: 18,
        name: "Polyester Ceiling Tiles",
        category: "ceiling",
        route: "/polyester-ceiling-tiles",
        status: "available",
        image: PolyesterCT,
        description: "Polyester Ceiling Tiles are durable acoustic tiles that reduce echo while providing moisture-resistant and dust-free performance."
    },
];

function ProductCards() {

    const [activeCategory, setActiveCategory] = useState("all");

    const filteredProducts = activeCategory === "all" ? products : products.filter((item) => item.category === activeCategory);

    return (
        <>
            <div className="product-header">
                {["all", "wall", "ceiling", "baffle", "designer", "floor"].map((cat) => (
                    <button
                        type="button"
                        key={cat}
                        className={`product-nav-link ${activeCategory === cat ? "active" : ""
                            }`}
                        onClick={() => setActiveCategory(cat)}
                    >
                        {cat === "all" && "All Products"}
                        {cat === "wall" && "Acoustic Wall Panels"}
                        {cat === "ceiling" && "Acoustic Ceiling Panels"}
                        {cat === "baffle" && "Acoustic Baffles"}
                        {cat === "designer" && "Designer Panels"}
                        {cat === "floor" && "Floor Panels"}
                    </button>
                ))}
            </div>

            <div className="cards-container">
                {filteredProducts.map((item) => (
                    <div className="product-card" key={item.id}>
                        <img src={item.image} alt={item.name} className="product-card-bg" />

                        {/* <div className="product-card-overlay"></div> */}

                        {/* <div className="product-card-status">
                            <span className={`dot ${item.status}`}></span>
                            {item.status}
                            <h3>{item.name}</h3>
                        </div> */}

                        <div className="product-card-content">
                            <h3 dangerouslySetInnerHTML={{ __html: item.name }} />

                            {/* <div className="product-card-tags">
                                ⭐ {item.rating} | 👥 {item.users}
                            </div> */}

                            {/* <p>{item.description}</p> */}

                            <Link to={item.route}><button className="product-card-btn">View Product</button></Link>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default ProductCards;